PF.Entity.EventsTrait = class EventsTrait extends PF.Entity.EventsCoreTrait
	{


	once(name, callback, callOnInit)
		{
		let onceCallback = (...args) => {
			callback(...args);
			this.off(name, onceCallback);
		};
		this.on(name, onceCallback, callOnInit);
		}

	onChange(key, callback, callOnInit = false)
		{
		if (key instanceof Array)
			{
			for (let i = 0; i < key.length; i++)
				{
				this.onChange(key[i], callback, false);
				}
			if (callOnInit === true)
				{
				callback();
				}
			return;
			}
		key = key.split('.');
		key[key.length - 1] = 'change:' + key[key.length - 1];
		key = key.join('.');
		this.on(key, callback, callOnInit);
		}

	onChangeDebounce(key, callback, delay = 10, callOnInit = false)
		{
		if (key instanceof Array)
			{
			for (let i = 0; i < key.length; i++)
				{
				this.onChangeDebounce(key[i], callback, delay, false);
				}
			if (callOnInit === true)
				{
				callback();
				}
			return;
			}
		key = key.split('.');
		key[key.length - 1] = 'change:' + key[key.length - 1];
		key = key.join('.');
		this.onFinish(key, callback, delay, callOnInit);
		}

	onChangeOnce(key, callback)
		{
		key = key.split('.');
		key[key.length - 1] = 'change:' + key[key.length - 1];
		key = key.join('.');
		this.once(key, callback);
		}

	onValue(key, value, callback, callOnInit = true)
		{
		this.onChange(key, () => {
			if (value === this.get(key))
				{
				callback();
				}
		}, callOnInit);
		}

	onValueOnce(key, value, callback)
		{
		if (value === this.get(key))
			{
			callback();
			}
		else
			{
			let event = key.split('.');
			event[event.length - 1] = 'change:' + event[event.length - 1];
			event = event.join('.');

			let changeCallback = () => {
				if (value === this.get(key))
					{
					callback();
					this.off(event, changeCallback);
					}
			};
			this.on(event, changeCallback);
			}
		}

	calc(key, source, callback)
		{
		if (callback === undefined)
			{
			callback = (value) => value;
			}
		if (typeof source === 'string')
			{
			source = [{object: this, key: source}];
			}
		else if (typeof source === 'object')
			{
			if (source.constructor.name === 'Array')
				{
				for (let i = 0; i < source.length; i++)
					{
					if (typeof source[i] === 'string')
						{
						source[i] = {object: this, key: source[i]};
						}
					}
				}
			else if (source.constructor.name === 'Object')
				{
				source = [source];
				}
			}

		let setValue = () => {
			let args = [];
			for (let j = 0; j < source.length; j++)
				{
				args.push(source[j].object.get(source[j].key));
				}
			this.set(key, callback(...args));
		};

		for (let i = 0; i < source.length; i++)
			{
			source[i].object.onChange(source[i].key, setValue);
			}

		setValue();
		}

	connect(notInitedParam, initedParam)
		{
		if (typeof notInitedParam === 'string')
			{
			notInitedParam = {[notInitedParam]: (v) => v};
			}
		let key1 = Object.keys(notInitedParam)[0];
		let callback1 = notInitedParam[key1];

		if (typeof initedParam === 'string')
			{
			initedParam = {[initedParam]: (v) => v};
			}
		let key2 = Object.keys(initedParam)[0];
		let callback2 = initedParam[key2];

		this.calc(key1, key2, callback1);
		this.calc(key2, key1, callback2);
		}

	bindDom(binders, source, callback)
		{
		if (this.dom === undefined)
			{
			this.dom = new PF.Dom();
			}
		let key = [];
		for (let nodeName in binders)
			{
			key.push(nodeName + '_' + binders[nodeName]);
			}
		key = 'connect_' + key.join('_');

		for (let nodeName in binders)
			{
			let bindersArray = binders[nodeName];
			if (typeof bindersArray === 'string')
				{
				bindersArray = [bindersArray];
				}
			for (let i = 0; i < bindersArray.length; i++)
				{
				let binder = bindersArray[i];
				// this.bindHtml();
				// this.bindText();
				// this.bindDisplay();
				// this.bindClasses();
				// this.bindAttributes();
				// this.bindFocus();
				// this.bindValue();
				if (binder === 'show')
					{
					this.dom[nodeName].bindDisplay();
					this.calc(`dom.${nodeName}.display`, key);
					}
				else if (binder === 'hide')
					{
					this.dom[nodeName].bindDisplay();
					this.calc(`dom.${nodeName}.display`, key, (v) => !v);
					}
				else if (binder === 'content')
					{
					this.dom[nodeName].bindContent();
					this.calc(`dom.${nodeName}.content`, key);
					}
				else if (binder === 'html')
					{
					this.dom[nodeName].bindHtml();
					this.calc(`dom.${nodeName}.html`, key);
					}
				else if (binder === 'text')
					{
					this.dom[nodeName].bindText();
					this.calc(`dom.${nodeName}.text`, key);
					}
				else if (binder === 'focus')
					{
					this.dom[nodeName].bindFocus();
					this.calc(`dom.${nodeName}.focus`, key);
					}
				else if (binder.indexOf('class:') === 0)
					{
					this.dom[nodeName].bindClasses();
					let [binder1, className] = binder.split(':');
					this.calc(`dom.${nodeName}.classes.${className}`, key);
					}
				else if (binder.indexOf('css:') === 0)
					{
					this.dom[nodeName].bindStyles();
					let [binder1, property] = binder.split(':');
					this.calc(`dom.${nodeName}.styles.${property}`, key);
					}
				else if (binder.indexOf('attr:') === 0)
					{
					this.dom[nodeName].bindAttributes();
					let [binder1, attrName] = binder.split(':');
					this.calc(`dom.${nodeName}.attributes.${attrName}`, key);
					}
				}
			}
		this.calc(key, source, callback);
		}

	calcString(key, object = this)
		{
		let init = true;
		let selfCall = false;
		let changeSlot = () => {
			if (selfCall === false)
				{
				let string = this.get(key, '', '');
				let offset = 0;
				let setValue = () => {
					let value = object.applyContext(string);
					selfCall = true;
					this.set(key, value);
					selfCall = false;
				};
				while (string.indexOf('@{', offset) > -1)
					{
					let begin = string.indexOf('@{', offset) + 2;
					let end = string.indexOf('}', begin);
					let key = string.substring(begin, end);
					object.onChange(key, setValue);
					offset = begin + 1;
					}
				if (init === true)
					{
					setValue();
					init = false;
					}
				}
		};
		object.onChange(key, changeSlot);
		changeSlot();
		};


	onStart(eventName, callback, delay, onInit = false)
		{
		if (onInit === true)
			{
			callback();
			}
		let isTriggered = false;
		let timeout;
		let onEvent = () => {
			if (isTriggered === false)
				{
				isTriggered = true;
				callback();
				timeout = setTimeout(() => {
					isTriggered = false;
				}, delay);
				}
			else
				{
				clearTimeout(timeout);
				timeout = setTimeout(() => {
					isTriggered = false;
				}, delay);
				}
		};
		this.on(eventName, onEvent);
		};

	onFinish(eventName, callback, delay, onInit = false)
		{
		if (onInit === true)
			{
			callback();
			}
		let isTriggered = false;
		let onEvent = () => {
			if (isTriggered === false)
				{
				isTriggered = true;
				setTimeout(() => {
					callback();
					isTriggered = false;
				}, delay);
				}
		};
		this.on(eventName, onEvent);
		};

	onEvery(eventName, callback, delay, onInit = false)
		{
		if (onInit === true)
			{
			callback();
			}
		let isTriggered = false;
		let onEvent = () => {
			if (isTriggered === false)
				{
				isTriggered = true;
				setTimeout(() => {
					callback();
					isTriggered = false;
				}, delay);
				}
		};
		this.on(eventName, onEvent);
		};

	onStartEvery(eventName, callback, delay, onInit = false)
		{
		if (onInit === true)
			{
			callback();
			}
		let isStartTriggered = false;
		let isEveryTriggered = false;
		let startTimeout;
		let onEvent = () => {

			if (isStartTriggered === false)
				{
				callback();
				isStartTriggered = true;
				startTimeout = setTimeout(() => {
					isStartTriggered = false;
				}, delay);
				}
			else
				{
				clearTimeout(startTimeout);
				startTimeout = setTimeout(() => {
					isStartTriggered = false;
				}, delay);

				if (isEveryTriggered === false)
					{
					isEveryTriggered = true;
					setTimeout(() => {
						callback();
						isEveryTriggered = false;
					}, delay);
					}
				}
		};
		this.on(eventName, onEvent);
		};

	onStartFinish(eventName, callback, delay, onInit = false)
		{
		if (onInit === true)
			{
			callback();
			}
		let isStartTriggered = false;
		let isTriggered = false;
		let startTimeout;
		let onEvent = () => {
			if (isStartTriggered === false)
				{
				callback();
				isStartTriggered = true;
				startTimeout = setTimeout(() => {
					isStartTriggered = false;
				}, delay);
				}
			else
				{
				clearTimeout(startTimeout);
				startTimeout = setTimeout(() => {
					isStartTriggered = false;
					callback();
				}, delay);

				}
		};
		this.on(eventName, onEvent);
		};

	applyContext(string, context = this)
		{
		return PF.H.applyContext(string, context);
		}
	};